(function () {
  var overlay = document.getElementById('dope-news-popup');
  if (!overlay) return;

  var STORAGE_KEY = 'dnp_last_shown';
  var showRule = overlay.dataset.showOnce; // "always" | "session" | "day" | "week"
  var delay = parseInt(overlay.dataset.delay, 10) || 0;
  var autoplay = overlay.dataset.autoplay === 'true';
  var autoplaySpeed = parseInt(overlay.dataset.autoplaySpeed, 10) || 6000;

  function shouldShow() {
    if (showRule === 'always') return true;

    var raw = null;
    try {
      if (showRule === 'session') {
        raw = sessionStorage.getItem(STORAGE_KEY);
      } else {
        raw = localStorage.getItem(STORAGE_KEY);
      }
    } catch (e) {
      return true; // storage blocked, fail open
    }

    if (!raw) return true;

    if (showRule === 'session') return false;

    var last = parseInt(raw, 10);
    if (isNaN(last)) return true;

    var now = Date.now();
    var elapsed = now - last;
    var threshold = showRule === 'day' ? 86400000 : 604800000; // 1 day / 1 week
    return elapsed > threshold;
  }

  function markShown() {
    var now = Date.now().toString();
    try {
      if (showRule === 'session') {
        sessionStorage.setItem(STORAGE_KEY, now);
      } else if (showRule !== 'always') {
        localStorage.setItem(STORAGE_KEY, now);
      }
    } catch (e) { /* ignore */ }
  }

  if (!shouldShow()) return;

  var track = overlay.querySelector('.dnp-track');
  var slides = overlay.querySelectorAll('.dnp-slide');
  var dots = overlay.querySelectorAll('.dnp-dot-btn');
  var closeBtns = overlay.querySelectorAll('.dnp-close, .dnp-close-secondary');
  var currentIndex = 0;
  var autoplayTimer = null;

  function goTo(index) {
    if (!slides.length) return;
    currentIndex = (index + slides.length) % slides.length;
    track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === currentIndex);
    });
  }

  function nextSlide() { goTo(currentIndex + 1); }
  function prevSlide() { goTo(currentIndex - 1); }

  function startAutoplay() {
    if (!autoplay || slides.length <= 1) return;
    stopAutoplay();
    autoplayTimer = setInterval(nextSlide, autoplaySpeed);
  }
  function stopAutoplay() {
    if (autoplayTimer) clearInterval(autoplayTimer);
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      goTo(parseInt(dot.dataset.index, 10));
      startAutoplay();
    });
  });

  // Drag / swipe support
  var isDragging = false;
  var hasMoved = false;
  var startX = 0;
  var currentTranslate = 0;
  var trackWidth = 0;
  var MOVE_THRESHOLD = 6; // px — abaixo disto conta como clique, não arrasto

  function getX(e) {
    return (e.touches ? e.touches[0].clientX : e.clientX);
  }

  function dragStart(e) {
    if (slides.length <= 1) return;
    isDragging = true;
    hasMoved = false;
    stopAutoplay();
    startX = getX(e);
    trackWidth = track.parentElement.getBoundingClientRect().width;
    currentTranslate = -(currentIndex * trackWidth); // sincroniza com a posição real atual
    track.classList.add('is-dragging');
  }

  function dragMove(e) {
    if (!isDragging) return;
    var deltaX = getX(e) - startX;
    if (Math.abs(deltaX) > MOVE_THRESHOLD) hasMoved = true;
    if (!hasMoved) return; // ignora micro-movimentos de um clique normal
    var baseTranslate = -(currentIndex * trackWidth);
    currentTranslate = baseTranslate + deltaX;
    track.style.transform = 'translateX(' + currentTranslate + 'px)';
  }

  function dragEnd() {
    if (!isDragging) return;
    isDragging = false;
    track.classList.remove('is-dragging');

    if (!hasMoved) {
      // foi um clique/tap, não um arrasto — não mexe no slide
      hasMoved = false;
      return;
    }

    var deltaX = currentTranslate - (-(currentIndex * trackWidth));
    var threshold = trackWidth * 0.18;
    if (deltaX < -threshold) {
      nextSlide();
    } else if (deltaX > threshold) {
      prevSlide();
    } else {
      goTo(currentIndex);
    }
    hasMoved = false;
    startAutoplay();
  }

  track.addEventListener('mousedown', dragStart);
  track.addEventListener('touchstart', dragStart, { passive: true });
  window.addEventListener('mousemove', dragMove);
  track.addEventListener('touchmove', dragMove, { passive: true });
  window.addEventListener('mouseup', dragEnd);
  track.addEventListener('touchend', dragEnd);

  function openPopup() {
    overlay.classList.add('is-visible');
    overlay.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      overlay.classList.add('is-active');
    });
    startAutoplay();
    markShown();
  }

  function closePopup() {
    overlay.classList.remove('is-active');
    stopAutoplay();
    setTimeout(function () {
      overlay.classList.remove('is-visible');
      overlay.setAttribute('aria-hidden', 'true');
    }, 300);
  }

  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', closePopup);
  });

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-visible')) closePopup();
  });

  setTimeout(openPopup, delay);
})();